import axios from "axios";
import { Auth } from "aws-amplify";


import env from '../env.json'

// const [token,setToken] = useLocalStorage('token',null);

let axiosWithAuth = axios
    .create({
        baseURL: env.api_url,
    });
axiosWithAuth.interceptors.request.use((req) => {
    let token = JSON.parse(localStorage.getItem('token'));
    req.headers.Authorization = `Bearer ${token}`
    return req;
}, (err) => {
    return Promise.reject(err)
})
axiosWithAuth.interceptors.response.use((res) => {
    // console.log('AxiosWithAuthErr:')
    // console.log(res)
    return res
}, (err) => {
    if (err.response?.status === 401) {
        // Clear every key Authprovider.js persists, not just token - a
        // partial clear left `user`/`platform` behind while `token` was
        // gone, so NavBar (reading those directly) kept rendering as
        // logged in while ProtectedRoute redirected to the login form
        // underneath it. A hard redirect (rather than relying on React
        // state, which none of this - a plain axios module - has access
        // to) also guarantees every useLocalStorage hook re-reads the now
        // -cleared values fresh instead of holding a stale in-memory copy.
        ['token', 'user', 'groups', 'platform', 'platform_config', 'real_groups', 'real_platform', 'real_platform_config']
            .forEach(key => localStorage.removeItem(key));
        Auth.signOut().finally(() => {
            window.location.href = '/login';
        });
    }
    return Promise.reject(err)
})
export default axiosWithAuth;